import React from "react";
import { Icons } from "../../config/MuiIcons.config";
import "./DailyChallengeCard.style.css";

const DailyChallengeCard = ({ onClick }) => {
  return (
    <div className="daily-challenge-card" onClick={onClick}>
      <div className="daily-challenge-content">
        <div className="daily-challenge-text">
          <h2 className="daily-challenge-title">Daily Challenge</h2>
          <p className="daily-challenge-description">
            Complete today's passage and compete on the leaderboard!
          </p>
        </div>
        <button className="daily-challenge-button" aria-label="Go to Daily Challenge">
          <span className="daily-challenge-chevron">
            <Icons.RightArrowAngleIcon />
          </span>
        </button>
      </div>
    </div>
  );
};

export default DailyChallengeCard;

